<div *ngIf="alertField?.invalid && (alertField?.touched || alertField?.dirty)" class="text-danger" [ngClass]="{'ms-4':marginClass}">
    <span *ngIf="alertField?.errors?.['required']">This field is required.</span>
    <span *ngIf="alertField?.errors?.['min'] && isDefinedNumber(minValue)">Minimum value is {{ minValue }}.</span>
    <span *ngIf="alertField?.errors?.['max'] && isDefinedNumber(maxValue)">Maximum value is {{ maxValue }}.</span>
</div>
